import { Box, Card, Text, useTheme, useColorModeValue } from "@chakra-ui/react";
import Overline from "./Overline";

function MapScenesLegend(){
  const theme = useTheme();
  const mapLegendBg = useColorModeValue("base.50", "base.500");
  return (
    <Card
      position="absolute"
      bottom="12"
      w="fit-content"
      minW="18rem"
      left={2.5}
      p={3}
      fontFamily={theme.fonts.body}
      zIndex="1020"
      background={mapLegendBg}
      border="1px solid var(--chakra-colors-chakra-border-color)"
      display="flex"
      flexDir="column"
    >
      <Overline mb={2}>
        Scenes
      </Overline>
      <Box w="100%" h="4" bgGradient="linear(to-r, transparent, primary.500)" />
      <Box display="flex" justifyContent="space-between">
        <Text fontSize="xs" fontWeight="semibold">Less</Text>
        <Text fontSize="xs" fontWeight="semibold">More</Text>
      </Box>
    </Card>
  );
}

export default MapScenesLegend;
